const imagesTop = document.querySelectorAll(".team-joola-slider .swiper-slide");

function clearActiveImage (target) {
  let sliderImages = target.closest("slider-element").querySelectorAll(".team-joola-slider .swiper-slide");
  sliderImages.forEach(function (image) {
    image.classList.remove("active");
  });
}

imagesTop.forEach(function (image, index) {
  image.onclick = function (event) {
    if (!imagesTop[index].classList.contains("active")) {
      clearActiveImage(event.target);
      imagesTop[index].classList.add("active");
    }
  };
});
